export default __webpack_public_path__ + "alberta-dashboard.0ed4f8c8cb9a33021f23.svg";